// Runtime overrides injected by docker-entrypoint.sh as `env.js`, loaded
// synchronously before the main bundle so this constant is populated by the
// time settings is first read. See `/docker-entrypoint.sh` and the
// `<script src="/env.js">` tag in `web-build/index.html`. When running the
// dev server (no entrypoint), `runtime` is empty and the fallbacks below are
// used.
const runtime = (typeof window !== "undefined" && window.__ENV__) || {};

const settings = {
  // Backend is the fusionpbx-business-bff root. Auth endpoints live at
  // `${apiUrl}/auth/*`; PBX traffic is proxied under `${apiUrl}/fusion/api/*`
  // (App.js does the suffix wiring).
  apiUrl: runtime.apiUrl || "https://bff.ntlk.co",

  // Single-tenant deployments inject SELECTION_DOMAIN into env.js so the
  // auth form can pre-fill (or hide) the alias field. Empty string means
  // multi-tenant — the user has to enter their own alias on sign-in.
  defaultDomain: runtime.domain || "",

  apiNotificationUrl: "https://api.mds.nettalk.com",
  apiNotificationAuth: "b3NjYXJhOnBhc3N3b3JkMUE=",

  pageSizeLoad: 25,
  mobileSize: 880,

  accountPrefixApp: "9998",
  accountPrefixPhy: "9999",

  permissionTypeView: "view",
  permissionTypeEdit: "edit",

  // Feature flag — the calling-card module (PIN management, PIN CDRs, calling
  // rates, report schedule + the calling-card stats on the dashboard). Only
  // maritime/cruise tenants use it, so it's OFF by default and must be opted
  // into per deployment. Runtime-injected via env.js like `apiUrl` — set
  // `CALLING_CARDS_ENABLED=true` on the container (env.js emits it as the
  // string "true"). Any other/absent value leaves it disabled.
  callingCardsEnabled:
    runtime.callingCardsEnabled === true ||
    runtime.callingCardsEnabled === "true",

  // Anthropic model used by the setup wizard's AI assistant step to propose a
  // starter PBX plan. The Anthropic key now lives server-side: the wizard calls
  // the BFF's transparent `/anthropic` proxy (at `${apiUrl}/anthropic`) with the
  // signed-in user's access token, and the BFF injects the real x-api-key. No
  // Anthropic key is shipped in the browser bundle anymore. See src/api/anthropic.js.
  anthropicModel: "claude-sonnet-4-6",
};

export default settings;
